var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert"},_vm._l((_vm.alerts),function(alert,index){return _c('v-alert',{key:index,attrs:{"type":alert.type}},[_vm._v(" "+_vm._s(_vm.$t(alert.code))+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }